<template>
    <div>
        <div class="treetitle">
            <div class="tree-header-left">
                <img src="../assets/icon_level.svg" style="height:15px;vertical-align:middle"/><span v-t="'message.item_layerId'"></span>
                <img src="../assets/user.svg" style="padding-left:10px;height:15px;vertical-align:middle"/><span v-t="'message.item_userId_displayName'"></span>
                <img src="../assets/group.svg" style="padding-left:10px;height:18px;vertical-align:middle"/><span v-t="'message.item_groupId'"></span>
            </div>
        </div>
        <el-tree v-if="show"
            class="common-object-tree"
            :props="properties"
            :load="loadNode"
            node-key="name"
            ref="tree"
            lazy
            highlight-current
            :default-expanded-keys="initialGroup.nodeList"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            :render-content="renderContent">
        </el-tree>
   </div>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
        return {
            show: false,
            loadingScreen: null,
            properties: {
                label: 'label',
                isLeaf: 'isLeaf',
            },
            initialGroup: {
                fullPath: null,
                nodeList: [],
                groupName: null,
            },
        };
    },
    props: {
        initialData: Object,
    },
    methods: {
        handleNodeClick(data, node, elNode) {
            if(node.data.type == constants.OBJECT_TALKGROUP) {
                if (node.childNodes.length == 0) {
                    this.loadingScreen = this.$loading({
                            lock: true ,
                            text: 'Loading data ...' ,
                            spinner: 'el-icon-loading' ,
                            background: 'rgba(0, 0, 0, 0)'
                    });
                    let self = this;
                    let userDataList = [];
                    server.post('/gettalkerlist', {tenantId: node.data.tenantId, talkgroupId: node.data.id})
                    .then((res) => {
                        switch(res.data.status) {
                            case constants.STATUS_SUCCESS:
                                userDataList = self.getTalkerListNodeData(res.data.nodeInfo);
                                break;
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleNodeClick").replace("{code}",res.data.status));
                                break;
                        }
                        if (data.length == 0) {
                            node.loading = true;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        } else {
                            for (let index = 0 ; index < userDataList.length ; index ++) {
                                if (index == 0) {
                                    self.$refs.tree.append(userDataList[index], node);
                                } else {
                                    self.$refs.tree.insertAfter(userDataList[index], node.childNodes[index -1]);
                                }
                            }
                        }
                        self.closeLoadingScreen();
                        self.$emit('on-selectnode', elNode)
                    })
                    .catch( function ( error ) {
                        self.closeLoadingScreen();
                        commonUtil.putExceptionErrorMessage(self, "handleNodeClick", error);
                    });
                } else {
                    this.$emit('on-selectnode', elNode)
                }
            } else {
                this.$emit('on-selectnode', elNode)
            }
        },
        reload() {
            this.show = false;
            this.$nextTick(() => {
                 this.show = true
            })
        },
        loadNode(node, resolve) {
            if (node.parent == null) {
                if (this.initialData.length > 0) {
                    resolve(this.initialData);
                }
                return;
            }
            let self = this;

            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            switch(node.data.type) {
                case constants.OBJECT_NODE:
                    server.post('/getchildren', {tenantId: node.data.tenantId, parentId: node.data.id , type: -1})
                    .then((res) => {
                        if (res.data.status >= 0) {
                            let data = [];
                            for (let i = 0; i < res.data.nodeInfo.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.nodeInfo[i].id,
                                    name: res.data.nodeInfo[i].name,
                                    label: res.data.nodeInfo[i].name,
                                    type: res.data.nodeInfo[i].type,
                                    isLeaf: res.data.nodeInfo[i].hasChild  == 0 ? true : false
                                });
                            }
                            for (let i = 0; i < res.data.talkGroupInfos.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.talkGroupInfos[i].talkgroupId,
                                    name: res.data.talkGroupInfos[i].talkgroupName,
                                    label: res.data.talkGroupInfos[i].talkgroupName,
                                    type: constants.OBJECT_TALKGROUP,
                                    isLeaf: false
                                });
                            }
                            data.sort(function(e1, e2) {
                                if (e1.type < e2.type) return -1;
                                else if (e1.type > e2.type) return 1;
                                else {
                                    let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                    if (comparisonResult < 0) return -1;
                                    else if (comparisonResult > 0) return 1;
                                }
                                return 0;
                            });
                            resolve(data)
                            if ((self.initialGroup != null) && !self.initGroupSelected) {
                                self.checkInitialDisplayGroup(data);
                            }
                        } else {
                            switch(res.data.status) {
                                case constants.STATUS_ERROR_DENIED:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied") );
                                    break;
                                default:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","loadNode-2").replace("{code}",res.data.status));
                                    break;
                            }
                            node.loading = false;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        }
                        self.closeLoadingScreen();
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                        self.closeLoadingScreen();
                    });
                    return;
                case constants.OBJECT_TALKGROUP:
                    server.post('/gettalkerlist', {tenantId: node.data.tenantId, talkgroupId: node.data.id})
                    .then((res) => {
                        if (res.data.status >= 0) {
                            let userDataList = [];
                            userDataList = self.getTalkerListNodeData(res.data.nodeInfo);
                            resolve(userDataList);
                        } else {
                            switch(res.data.status) {
                                case constants.STATUS_ERROR_DENIED:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied"));
                                    break;
                                default:
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","loadNode-1").replace("{code}",res.data.status));
                                    break;
                            }
                            node.loading = false;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        }
                        self.closeLoadingScreen();
                    })
                    .catch( function ( error ) {
                        self.closeLoadingScreen();
                        commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                    });
                    return;
            }
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            switch (data.type) {
                case constants.OBJECT_NODE:
                    if (data.id == 1) {
                        objectIcon = require("../assets/icon_tenant.svg");
                    } else {
                        objectIcon = require("../assets/icon_level.svg");
                    }
                    break;
                case constants.OBJECT_USER:
                    objectIcon = require("../assets/user.svg");
                    break;
                case constants.OBJECT_TALKGROUP:
                    objectIcon = require("../assets/group.svg");
                    break;
            }

            return h("span", [h("img", { attrs: { src: objectIcon ,height: "20px", style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        getTalkerListNodeData(nodeData) {
            let data = [];
            for (let i = 0; i < nodeData.length; i++) {
                data.push({
                    tenantId: nodeData[i].tenantId,
                    id: nodeData[i].id,
                    name: nodeData[i].name,
                    label: nodeData[i].name + " / " + nodeData[i].displayName,
                    type: constants.OBJECT_USER,
                    markerIcon: nodeData[i].markerIcon,
                    displayName: nodeData[i].displayName,
                    type: constants.OBJECT_USER,
                    isLeaf: true
                })
            }
            data.sort(function(e1, e2) {
                if (e1.type < e2.type) return -1;
                else if (e1.type > e2.type) return 1;
                else {
                    let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                    if (comparisonResult < 0) return -1;
                    else if (comparisonResult > 0) return 1;
                }
                return 0;
            });
            return data;
        },
        checkInitialDisplayGroup(dataList) {
            for (let data of dataList) {
                if (data.type == constants.OBJECT_TALKGROUP) {
                    if (data.label == this.initialGroup.groupName) {
                        this.initGroupSelected = true;
                        this.$refs.tree.setCurrentKey(data.name);
                        this.$emit('onInitGroup', this.$refs.tree.getNode(data.name));
                    }
                }
            }
        },
    },
    created: function () {
        this.initialGroup.fullPath = sessionStorage.getItem('trackingGroup');
        if (this.initialGroup.fullPath != null) {
            this.initialGroup.nodeList.push("ROOT-NODE");
            let nodeItems = this.initialGroup.fullPath.split("\\");
            if (nodeItems.length == 1) {
                this.initialGroup.groupName = nodeItems[0];
            } else {
                for (let index = 0 ; index < nodeItems.length ; index++) {
                    if (index == (nodeItems.length - 1)) {
                        this.initialGroup.groupName = nodeItems[index];
                    } else {
                        this.initialGroup.nodeList.push(nodeItems[index]);
                    }
                }
            }
        } else {
            this.initialGroup.nodeList.push("ROOT-NODE");
        }
        this.show = true;
    },
    watch: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ecf1fa !important;
}

.el-tree-node > .el-tree-node__content:hover {
    background-color: #ecf1fa !important;
}
.el-tree-node__content {
    height: 40px !important;
}
.el-tree-node__content img {
    margin-left: -20px !important;
    padding-right: 8px !important;
}
.el-tree-node__expand-icon {
    padding: 28px !important;
}

</style>

<style scoped>

.tree-command-text {
    padding-left: 5px;
    display: inline-block;
    font-size: 12px;
    color: #5171cb;
    vertical-align: middle;
}
.tree-command-text:hover {
    opacity: 0.7;
}

button.tree-command-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    padding-top: 10px;
}

.tree-header-left {
    vertical-align: middle;
    padding-top: 12px;
    padding-left: 20px;
    float: left;
}
.tree-header-right {
    text-align : right;
    vertical-align: middle;
    padding-top: 2px;
    padding-bottom: 3px;
    padding-right: 20px;
}

.treetitle {
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
    white-space: nowrap;
    height: 42px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
    min-width: 630px;
}
.modal-default-button {
  float: right;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.common-object-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.common-object-tree.el-tree {
    overflow-x: hidden;
    overflow-y: auto;
}
.common-object-tree.el-tree {
    width: 100%;
    height: calc(100vh - 105px);
}
</style>
